import type { FetchiosError } from "@caprikorn/dynamo-utils";
import { type QueryObserverOptions, useQuery } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";
import { GROUP_ID_LENGTH } from "@services/services.constants";

import type { GetGroup } from "./apiEcms.types";

const getGroup = async (reference: string | undefined, signal: AbortSignal) => {
  const { data } = await apiEcmsHttp.get<GetGroup>(`/groups/${reference}`, {
    signal,
  });

  return data;
};

export const useGetGroup = <TData = GetGroup>(props: {
  groupId: string;
  options?: Partial<QueryObserverOptions<GetGroup, FetchiosError, TData>>;
}) =>
  useQuery({
    queryKey: [QUERY_KEYS.GROUP, props.groupId],
    queryFn: ({ signal }) => getGroup(props.groupId, signal),
    ...props?.options,
    enabled: props.groupId.length === GROUP_ID_LENGTH,
  });
